// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { ComponentFactoryResolver, Type, DOCUMENT } from '@angular/core';
import { StoreModule } from '@ngrx/store';
// NgRx reducers
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { AccountSettingsNavigationModule } from 'AccountsApp/ts/features/navigation/account-settings-navigation.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// Component imports
import { AccountSettingsNavigationComponent } from 'AccountsApp/ts/features/navigation/account-settings-navigation.component';
import { NotificationPreferencesComponent } from 'AccountsApp/ts/apps/account-profile-communications-app/components/notification-preferences/notification-preferences.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { ApiKeyManagerComponent } from 'ApiApp/ts/features/api-key-manager/api-key-manager.component';
import { CancelAccountModalComponent } from 'AccountsApp/ts/apps/account-membership-app/components/cancel-account-pop-up/cancel-account-modal.component';
import { IconWrapperComponent } from 'NewAngular/features/components/icon-wrapper/icon-wrapper.component';
// Utils
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    AccountSettingsNavigationComponent,
    NotificationPreferencesComponent,
    TopBarNavComponent,
    SideMenuComponent,
];
export class AccountProfileCommunicationsModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [ApiKeyManagerComponent, CancelAccountModalComponent, IconWrapperComponent];
    }
}
AccountProfileCommunicationsModule.ɵfac = function AccountProfileCommunicationsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountProfileCommunicationsModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
AccountProfileCommunicationsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AccountProfileCommunicationsModule });
AccountProfileCommunicationsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AccountSettingsNavigationModule,
        BrowserModule,
        ConfigModule,
        FormsModule,
        HelpModalModule,
        NavigationModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        SingleSelectDropdownModule,
        IconModule,
        TooltipModule] });
